var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoutIcon = function SvgLogoutIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Log out"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 5V19C20 20.657 18.657 22 17 22H7C5.343 22 4 20.657 4 19V5C4 3.343 5.343 2 7 2H17C18.657 2 20 3.343 20 5Z",
    fill: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 10H11C9.895 10 9 10.895 9 12C9 13.105 9.895 14 11 14H18V10Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5801 16.1306C16.5801 16.9016 17.5101 17.2896 18.0581 16.7466L21.9511 12.8906C22.4461 12.3996 22.4461 11.5996 21.9511 11.1086L18.0581 7.25259C17.5101 6.71059 16.5801 7.09859 16.5801 7.86859V16.1306Z",
    fill: "#828282"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoutIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "logout-icon.4d7d57eda8897a550cd0f65c308dcb0e.svg";